(() => {
  'use strict';
  const root = document.getElementById('BlissChatPreview');
  if (!root || root.dataset.helpMode !== 'guided' || root.dataset.liveChatEnabled !== 'false') return;
  const dialog = root.querySelector('dialog');
  const launcher = root.querySelector('.bcp__launcher');
  const close = root.querySelector('.bcp__close');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const mobileHero = document.querySelector('.bliss-editorial-hero');
  const videoFrame = document.querySelector('.bliss-editorial-hero .beh-frame');
  const heroBadge = document.querySelector('.beh-certification img');
  const mobileViewport = window.matchMedia('(max-width: 749px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const launcherAvatar = launcher.querySelector('.bcp__avatar');
  const panelAvatar = dialog.querySelector('.bcp__avatar');
  const launcherImage = launcherAvatar && launcherAvatar.querySelector('img');
  const avatars = [launcherAvatar, panelAvatar].filter(Boolean);
  let entrancePlayed = false;
  const resetAvatar = avatar => avatar.classList.remove('bcp__avatar--arriving', 'bcp__avatar--responding');
  const stopAvatarMotion = () => avatars.forEach(resetAvatar);
  avatars.forEach(avatar => {
    avatar.addEventListener('animationend', () => resetAvatar(avatar));
    avatar.addEventListener('animationcancel', () => resetAvatar(avatar));
  });
  const respondToPointer = event => {
    if (event.detail > 0 && !reducedMotion.matches && panelAvatar) panelAvatar.classList.add('bcp__avatar--responding');
  };
  reducedMotion.addEventListener('change', stopAvatarMotion);
  root.addEventListener('keydown', stopAvatarMotion);
  launcher.addEventListener('focus', stopAvatarMotion);
  launcher.addEventListener('pointerenter', event => {
    if (event.pointerType !== 'mouse' || reducedMotion.matches || root.hidden || !launcherAvatar || launcher.matches(':focus-visible')) return;
    if (!launcherAvatar.classList.contains('bcp__avatar--arriving') && !launcherAvatar.classList.contains('bcp__avatar--responding')) launcherAvatar.classList.add('bcp__avatar--responding');
  });
  let scheduled = false;
  let measureTimer;
  const obstructionSelector = '#StickyFloatingCTA,#PBarNextFrameWrapper,#shopify-pc__banner,.shopify-pc__banner,#onetrust-banner-sdk,#CybotCookiebotDialog,.cc-window,[data-cookie-banner]';
  const consentSelector = '#shopify-pc__banner,.shopify-pc__banner,#onetrust-banner-sdk,#CybotCookiebotDialog,.cc-window,[data-cookie-banner]';
  const visible = (element) => {
    const box = element.getBoundingClientRect();
    const style = getComputedStyle(element);
    return box.width > 0 && box.height > 0 && box.bottom > 0 && box.top < window.innerHeight && style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0 && element.getAttribute('aria-hidden') !== 'true';
  };
  const restoreLauncher = () => {
    launcher.setAttribute('aria-expanded', 'false');
    if (!root.hidden) launcher.focus({ preventScroll: true });
  };
  const measure = () => {
    scheduled = false;
    clearTimeout(measureTimer);
    let bottom = 20;
    let consentVisible = false;
    document.querySelectorAll(obstructionSelector).forEach(element => {
      if (!visible(element)) return;
      const box = element.getBoundingClientRect();
      if (element.matches(consentSelector)) consentVisible = true;
      if (box.bottom >= window.innerHeight - 120) bottom = Math.max(bottom, window.innerHeight - box.top + 12);
    });
    const badgeBox = heroBadge && heroBadge.getBoundingClientRect();
    const badgeInView = Boolean(heroBadge && visible(heroBadge));
    const videoInView = Boolean(videoFrame && visible(videoFrame));
    const badgeAhead = Boolean(badgeBox && badgeBox.top >= window.innerHeight);
    const topClearance = badgeInView ? Math.max(16, Math.ceil(badgeBox.bottom + 16)) : 16;
    const dock = badgeInView ? 'badge' : 'floating';
    if (root.dataset.dock !== dock) root.dataset.dock = dock;
    const edge = badgeInView ? Math.max(12, document.documentElement.clientWidth - badgeBox.right) : (mobileViewport.matches ? 12 : 24);
    const edgeValue = `${Math.ceil(edge)}px`;
    if (root.style.getPropertyValue('--bcp-edge') !== edgeValue) root.style.setProperty('--bcp-edge', edgeValue);
    const topValue = `${topClearance}px`;
    if (root.style.getPropertyValue('--bcp-top-clearance') !== topValue) root.style.setProperty('--bcp-top-clearance', topValue);
    const focusWasInGuide = root.contains(document.activeElement);
    const wasOpen = dialog.open;
    let shouldHide = consentVisible || badgeAhead || (videoInView && !badgeInView);
    if (root.hidden !== shouldHide) root.hidden = shouldHide;
    const setBottom = () => {
      const nextBottom = `${Math.ceil(bottom)}px`;
      if (root.style.getPropertyValue('--bcp-bottom') !== nextBottom) root.style.setProperty('--bcp-bottom', nextBottom);
    };
    setBottom();
    if (!shouldHide) {
      const bookingLinks = [...document.querySelectorAll('a[href*="/onlinescheduling/"],.beh-play')].filter(visible);
      bookingLinks.sort((a, b) => b.getBoundingClientRect().top - a.getBoundingClientRect().top);
      bookingLinks.forEach(link => {
        const box = link.getBoundingClientRect();
        const dock = launcher.getBoundingClientRect();
        const overlaps = dock.left < box.right + 8 && dock.right > box.left - 8 && dock.top < box.bottom + 8 && dock.bottom > box.top - 8;
        if (overlaps) {
          if (badgeInView) shouldHide = true;
          else {
            bottom = Math.max(bottom, window.innerHeight - box.top + 12);
            setBottom();
          }
        }
      });
      if (badgeInView) {
        const roomBelowBadge = window.innerHeight - bottom - topClearance;
        if (dialog.open && roomBelowBadge < 380) dialog.close();
        if (roomBelowBadge < launcher.getBoundingClientRect().height) shouldHide = true;
      }
    }
    if (root.hidden !== shouldHide) root.hidden = shouldHide;
    if (shouldHide) stopAvatarMotion();
    else if (!entrancePlayed && (!launcherImage || launcherImage.complete)) {
      entrancePlayed = true;
      if (!reducedMotion.matches && !focusWasInGuide && launcherAvatar) launcherAvatar.classList.add('bcp__avatar--arriving');
    }
    if (shouldHide && dialog.open) dialog.close();
    if (shouldHide && !consentVisible && (wasOpen || focusWasInGuide)) {
      const main = document.getElementById('MainContent');
      if (main) main.focus({ preventScroll: true });
    }
  };
  const scheduleMeasure = () => {
    if (scheduled) return;
    scheduled = true;
    const run = () => {
      if (scheduled) measure();
    };
    measureTimer = setTimeout(run, 80);
    requestAnimationFrame(run);
  };
  launcher.addEventListener('click', event => {
    measure();
    if (root.hidden || dialog.open) return;
    if (root.dataset.dock === 'badge') {
      const bottom = parseFloat(root.style.getPropertyValue('--bcp-bottom')) || 20;
      const top = parseFloat(root.style.getPropertyValue('--bcp-top-clearance')) || 16;
      const shortfall = 380 - (window.innerHeight - bottom - top);
      if (shortfall > 0) {
        window.scrollBy({ top: Math.ceil(shortfall), behavior: 'instant' });
        measure();
        if (root.hidden) return;
      }
    }
    dialog.showModal();
    launcher.setAttribute('aria-expanded', 'true');
    close.focus({ preventScroll: true });
    respondToPointer(event);
  });
  close.addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', restoreLauncher);
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  const choices = [...root.querySelectorAll('details[data-faq-id]')];
  const storageKey = 'bliss-chat-preview-faq-v1';
  const duration = 30 * 60 * 1000;
  let expiryTimer;
  const removeChoice = () => {
    clearTimeout(expiryTimer);
    try { window.sessionStorage.removeItem(storageKey); } catch (_) {}
  };
  const storeChoice = (id) => {
    if (!choices.some(choice => choice.dataset.faqId === id)) return;
    removeChoice();
    try { window.sessionStorage.setItem(storageKey, JSON.stringify({ id, expires: Date.now() + duration })); } catch (_) {}
    expiryTimer = setTimeout(removeChoice, duration);
  };
  let restoredId = null;
  try {
    const stored = JSON.parse(window.sessionStorage.getItem(storageKey) || 'null');
    if (stored && Number.isFinite(stored.expires) && stored.expires > Date.now() && stored.expires <= Date.now() + duration && choices.some(choice => choice.dataset.faqId === stored.id)) {
      restoredId = stored.id;
      expiryTimer = setTimeout(removeChoice, stored.expires - Date.now());
    } else removeChoice();
  } catch (_) { removeChoice(); }
  choices.forEach(details => {
    const summary = details.querySelector('summary');
    if (summary) summary.addEventListener('click', event => {
      if (!details.open) respondToPointer(event);
    });
    if (details.dataset.faqId === restoredId) details.open = true;
    details.addEventListener('toggle', () => {
      if (!details.open) {
        if (!choices.some(choice => choice.open)) removeChoice();
        return;
      }
      choices.forEach(other => { if (other !== details) other.open = false; });
      if (details.dataset.faqId === restoredId) { restoredId = null; return; }
      storeChoice(details.dataset.faqId);
    });
  });
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    let stored = null;
    try { stored = JSON.parse(window.sessionStorage.getItem(storageKey) || 'null'); } catch (_) {}
    const valid = stored && Number.isFinite(stored.expires) && stored.expires > Date.now() && stored.expires <= Date.now() + duration && choices.some(choice => choice.dataset.faqId === stored.id);
    if (!valid) {
      removeChoice();
      restoredId = null;
      choices.forEach(choice => { choice.open = false; });
    } else {
      clearTimeout(expiryTimer);
      expiryTimer = setTimeout(removeChoice, stored.expires - Date.now());
      if (!choices.some(choice => choice.open && choice.dataset.faqId === stored.id)) {
        restoredId = stored.id;
        choices.forEach(choice => { choice.open = choice.dataset.faqId === stored.id; });
      }
    }
    measure();
  });
  root.querySelector('.bcp__clear').addEventListener('click', () => {
    removeChoice();
    restoredId = null;
    choices.forEach(choice => { choice.open = false; });
    const status = root.querySelector('.bcp__clear-status');
    status.textContent = status.dataset.cleared;
  });
  mobileViewport.addEventListener('change', measure);
  if (launcherImage && !launcherImage.complete) {
    launcherImage.addEventListener('load', scheduleMeasure, { once: true });
    launcherImage.addEventListener('error', scheduleMeasure, { once: true });
  }
  if (mobileHero && 'IntersectionObserver' in window) {
    new IntersectionObserver(scheduleMeasure, { threshold: 0 }).observe(mobileHero);
  }
  if (heroBadge) {
    heroBadge.addEventListener('load', scheduleMeasure);
    if ('ResizeObserver' in window) new ResizeObserver(scheduleMeasure).observe(heroBadge);
  }
  window.addEventListener('scroll', measure, { passive: true });
  window.addEventListener('resize', measure, { passive: true });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', measure, { passive: true });
  new MutationObserver(records => {
    if (records.some(record => !root.contains(record.target))) scheduleMeasure();
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] });
  measure();
})();




